import { render, staticRenderFns } from "./MetatraderAccounts.vue?vue&type=template&id=9a306866&scoped=true"
import script from "./MetatraderAccounts.vue?vue&type=script&lang=js"
export * from "./MetatraderAccounts.vue?vue&type=script&lang=js"
import style0 from "./MetatraderAccounts.vue?vue&type=style&index=0&id=9a306866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a306866",
  null
  
)

export default component.exports